import Route from 'cio/routes/base';

import Transition from '@ember/routing/-private/transition';
import MessageLibraryController from 'cio/pods/message-library/controller';

export default class MessageLibraryIndexRoute extends Route {
  setupController(controller: MessageLibraryController) {
    controller.setAllAvailableChannels();
  }
  resetController(controller: MessageLibraryController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setDefaults();
    }
  }

  crumb() {
    return {
      name: 'Message Library',
      path: 'message-library',
    };
  }
}
